// manual.js
import req from './axios';
import { isMockJs } from './axios'

export const manual = () => req('get', isMockJs ? '/manual/' : '/manual/');